export default "__VITE_ASSET__8PfW3z1K__"